import {
  Button,
  Flex,
  FormControl,
  Image,
  List,
  ListItem,
  Box,
  VStack,
  Heading,
} from "@chakra-ui/react";

import ResetPassSVG from "@root/assets/images/resetPassword.svg";
import { ErrorMessageText } from "@root/commonStyles/commonStyle";
import { PasswordInput } from "@root/components/common/passwordInput/passwordInput";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ResetPasswordTopHeading,
  ResetPasswordHeading,
  ResetPasswordSubHeading,
  ResetPasswordRequirements,
  ForgotPasswordForm,
  FormContainer,
} from "./styles";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setNewPassword, verifyResetPass } from "@root/store/thunks";
import { ROUTE_NAMES } from "@root/constants";
import { BrandedLogo } from "@root/components/branding";
import { LanguageToggle } from "@root/components/dashboard/sidebar/languagetoggler";

interface ResetPasswordValues {
  password: string;
  rePassword: string;
}
interface DisplayRequirementsProps {
  requirements: string;
}

export const ResetPassword: React.FC = () => {
  const { t } = useTranslation("common");
  const initialValues: ResetPasswordValues = {
    password: "",
    rePassword: "",
  };

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");
  const [loading, setLoading] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  console.log("isVerified", isVerified);
  const dispatch = useDispatch();

  const handleSucess = () => {
    setIsVerified(true);
  };

  useEffect(() => {
    if (token && !isVerified) {
      dispatch(verifyResetPass({ payload: token, onSuccess: () => handleSucess() }));
    }
  }, [token, isVerified]);

  const validate = (values: ResetPasswordValues) => {
    const errors: Partial<ResetPasswordValues> = {};
    if (!values.password) {
      errors.password = t("login.requiredPassword");
    } else if (values.password.length < 6) {
      errors.password = t("login.passwordValidation");
    }

    if (!values.rePassword) {
      errors.rePassword = t("resetPassword.confirmRequiredPassword");
    } else if (values.rePassword !== values.password) {
      errors.rePassword = t("resetPassword.samePasword");
    }

    return errors;
  };

  const navigate = useNavigate();
  const onSuccess = () => {
    setLoading(false);
    navigate(ROUTE_NAMES.RESET_SUCCESS);
  };
  const onSubmitHandler = (password: string) => {
    setLoading(true);
    dispatch(
      setNewPassword({
        payload: {
          password,
          token,
        },
        onSuccess,
        onError: () => setLoading(false),
      })
    );
  };

  const DisplayRequirements: React.FC<DisplayRequirementsProps> = ({
    requirements,
  }) => {
    const lines = requirements.split("\n");

    return (
      <Box
        fontSize="14px"
        alignItems="flex-start"
        justifyItems="start"
        fontWeight="400"
        color={"theme.gray.500"}
      >
        Requirements
        <ResetPasswordRequirements>
          <List spacing={1} alignItems="flex-start" justifyItems="start">
            {lines.map((line, index) => {
              if (line.startsWith("• ")) {
                return <ListItem key={index}>{line.trim()}</ListItem>;
              } else if (line.startsWith("  • ")) {
                return <ListItem key={index}>{line.trim()}</ListItem>;
              } else {
                return null;
              }
            })}
          </List>
        </ResetPasswordRequirements>
      </Box>
    );
  };

  return (
    <Box position="relative" minH="100vh">
      <LanguageToggle variant="public" position="absolute" top="20px" right="20px" zIndex={1000} />
      <FormContainer>
        <Box mt={"5rem"} mb={"15px"}>
          <BrandedLogo variant="full" />
        </Box>
        <Image src={ResetPassSVG} alt="Lock" mt="26px" />
        <ResetPasswordHeading>
          {t("resetPassword.resetYourPassword")}
        </ResetPasswordHeading>

        <Formik
          initialValues={initialValues}
          validate={validate}
          onSubmit={(e) => onSubmitHandler(e?.password)}
        >
          {({ handleSubmit, errors, touched, values, handleChange }) => (
            <ForgotPasswordForm
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              <VStack mt="28px" spacing={"24px"} align="flex-start">
                <FormControl isInvalid={!!errors.password && touched.password}>
                  <PasswordInput
                    onChange={handleChange}
                    value={values.password}
                    id="password"
                    name="password"
                    required
                    placeholder={t("resetPassword.password")}
                  />
                  <ErrorMessageText name="password" component="div" />
                </FormControl>
                <FormControl
                  isInvalid={!!errors.rePassword && touched.rePassword}
                >
                  <PasswordInput
                    onChange={handleChange}
                    value={values.rePassword}
                    id="rePassword"
                    name="rePassword"
                    required
                    placeholder={t("resetPassword.confirmPassword")}
                  />
                  <ErrorMessageText name="rePassword" component="div" />
                </FormControl>
                <ResetPasswordSubHeading>
                  {/* <DisplayRequirements
                  requirements={t("resetPassword.requirements")}
                /> */}
                </ResetPasswordSubHeading>
              </VStack>

              <Flex justifyContent="center" mt="20px">
                <Button
                  type="submit"
                  colorScheme="purple"
                  size="md"
                  isLoading={loading}
                  fontSize="16px"
                  background="purple.purpleGradient"
                  width="127px"
                  borderRadius="16px"
                >
                  {t("forgetPassword.continue")}
                </Button>
              </Flex>
            </ForgotPasswordForm>
          )}
        </Formik>
      </FormContainer>
    </Box>
  );
};
